import { useContext } from 'react';

import WorkOrderAssetView from '@atom/components/common/workOrderDetail/workOrderAssetView/WorkOrderAssetView';
import WorkOrderPreviewContext from '@atom/components/workOrderPreview/WorkOrderPreviewContext';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import TaskView from './taskView/TaskView';
import WorkOrderPreviewHeader from './workOrderPreviewHeader/WorkOrderPreviewHeader';

const MainView = () => {
  const {
    workOrderDetail,
    activeWorkOrderAsset,
    setActiveWorkOrderAsset,
    assetTreeViewState,
    setAssetTreeViewState,
    activeWorkAssetTaskId,
    refetch,
  } = useContext(WorkOrderPreviewContext);

  const showTaskView = isNilOrEmpty(activeWorkOrderAsset);

  return (
    <>
      <WorkOrderPreviewHeader />
      <div>
        {showTaskView ? (
          <TaskView />
        ) : (
          <WorkOrderAssetView
            key={activeWorkOrderAsset}
            workOrderDetail={workOrderDetail}
            rootAssetId={activeWorkOrderAsset}
            setActiveWorkOrderAsset={setActiveWorkOrderAsset}
            refetch={refetch}
            taskId={activeWorkAssetTaskId}
            viewState={assetTreeViewState[activeWorkOrderAsset]}
            onViewStateChange={setAssetTreeViewState}
            previewView
          />
        )}
      </div>
    </>
  );
};

export default MainView;
